import { useMemo } from "react";
import { Reveal } from "@/components/Reveal";
import { productImg } from "@/data/products";
import { useCatalog } from "@/hooks/useCatalog";

// Continuous marquee strip of "fresh off the printer" products. Pulls from the
// live catalog (print-shop-125) with local fallback.
export const ProductStrip = () => {
  const { products } = useCatalog();

  const strip = useMemo(() => {
    // vary from the featured grid: take a later slice, cap at 18
    const pool = products.length > 18 ? products.slice(4) : products;
    return pool.slice(0, 18);
  }, [products]);

  const items = [...strip, ...strip];

  return (
    <section className="relative overflow-hidden border-y border-border/60 bg-background/60 py-10">
      <Reveal>
        <div className="mx-auto mb-6 max-w-6xl px-4 sm:px-6 lg:px-8">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-neo-magenta">
            Fresh off the printer
          </span>
        </div>
      </Reveal>

      <div className="group relative flex w-full overflow-hidden">
        <div className="flex shrink-0 animate-[marquee_45s_linear_infinite] items-center gap-4 pr-4 group-hover:[animation-play-state:paused]">
          {items.map((p, i) => (
            <div
              key={p.slug + i}
              className="relative h-40 w-40 shrink-0 overflow-hidden rounded-2xl border border-border/70"
              style={{ background: "radial-gradient(circle at 50% 35%, #f6f8fc, #dfe5ee)" }}
            >
              <img
                src={productImg(p)}
                alt={p.name}
                loading="lazy"
                className="h-full w-full object-contain p-3"
              />
              <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent px-3 py-2">
                <span className="font-mono text-[10px] text-white">{p.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @media (prefers-reduced-motion: reduce) {
          .animate-\\[marquee_45s_linear_infinite\\] { animation: none !important; }
        }
      `}</style>
    </section>
  );
};
